import Scroll from "./components/Scroll.js";
import Header from "./components/Header.js";
import PageInteractions from "./components/PageInteractions.js";
import Spollers from "./components/Spollers.js";
import TableOfContents from "./components/TableOfContents";
import { api } from "./services/ApiService.js";
import PostsLoader from "./components/PostsLoader.js";
import PostsFilter from "./components/PostsFilter.js";
import FrontPage from "./pages/FrontPage.js";
import AboutPage from "./pages/AboutPage.js";

/**
 * Main App function
 */
const AGDSApp = () => {
    // Start Loader
    window.addEventListener("load", () => {
        document.body.classList.add("_show");
    });

    // Options
    const options = {
        overlay: document.getElementById("overlay"),
        preloader: document.getElementById("preloader"),
        header: document.getElementById("header"),
        spollersEls: document.querySelectorAll("[data-spollers]"),
        fancyBtns: document.querySelectorAll(".btn[data-fancybox]"),
        postsContainer: document.getElementById("posts-container"),
        filterContainer: document.getElementById("posts-filter"),
        teamSection: document.querySelector(".front-team-section"),
    };

    // Scroll
    const scroll = document.body
        ? new Scroll({
              header: options.header,
          })
        : null;
    scroll?.init();

    // Page Interactions
    const pageInteractions = document.body ? new PageInteractions() : null;
    pageInteractions?.init();

    // Spollers
    const spollers = options.spollersEls.length ? new Spollers() : null;
    spollers?.init();

    // Header
    const header = options.header
        ? new Header({
              header: options.header,
			  scroll
          })
        : null;
    header?.init();

    // PostLoader
    const postsLoader = options.postsContainer
        ? new PostsLoader({
              api: api,
              preloader: options.preloader,
              postsContainer: options.postsContainer,
          })
        : null;

    // FilterPosts
    const postsFilter =
        postsLoader && options.filterContainer
            ? new PostsFilter({
                  api: api,
                  preloader: options.preloader,
                  postsLoader: postsLoader,
                  postsContainer: options.postsContainer,
                  filterContainer: options.filterContainer,
              })
            : null;
    postsLoader?.init();
    postsFilter?.init();

    // Front page
    const frontPage = new FrontPage();
    frontPage?.init();

    // About page
    const aboutPage = new AboutPage();
    aboutPage?.init();

    // Table of contents
    const tableOfContents = new TableOfContents({
        contentSelector: ".post-content",
        tocSelector: ".table-of-contents",
        headingSelector: "h2",
        headerHeight: header?.headerHeightDetermination(),
    });
    tableOfContents?.init();
};

// Start App
document.addEventListener("DOMContentLoaded", AGDSApp);
